import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

/**
 * The one search box. Every screen had built its own: two carried a magnifier and two
 * did not, none offered a way to clear the field, and the placeholder was the only
 * label a screen reader ever got.
 */
export default function SearchInput({
  value, onChange, placeholder = "Search...", className, testid, autoFocus,
}) {
  return (
    <div className={cn("relative", className)}>
      <Search className="w-4 h-4 absolute left-3 top-3 text-muted-foreground pointer-events-none" aria-hidden="true" />
      <Input
        type="search"
        className="pl-9 pr-9 [&::-webkit-search-cancel-button]:appearance-none"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        autoFocus={autoFocus}
        data-testid={testid}
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange("")}
          aria-label="Clear search"
          data-testid={testid ? `${testid}-clear` : undefined}
          className="absolute right-2 top-2 p-0.5 rounded text-muted-foreground hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <X className="w-4 h-4" />
        </button>
      ) : null}
    </div>
  );
}
